export default __webpack_public_path__ + "static/media/policia.29492b70.png";